import { useLanguage } from '../contexts/LanguageContext';

// Hook personalizado para obtener traducciones de una sección específica
export const useTranslations = (section) => {
    const { getTranslations } = useLanguage();

    if (!section) {
        throw new Error('useTranslations requires a section parameter');
    }

    return getTranslations(section);
};

// Hook para obtener datos del hero
export const useHeroData = () => {
    const { getTranslations } = useLanguage();
    const heroData = getTranslations('hero');

    return {
        title: heroData.heroTitle,
        subtitle: heroData.heroSubtitle,
        landingSubtitle: heroData.landingSubtitle,
        inspirationalMessage: heroData.inspirationalMessage,
        inspirationalSubtext: heroData.inspirationalSubtext,
        viewServices: heroData.viewServices,
        contactNow: heroData.contactNow,
        discoverMore: heroData.discoverMore,
        featuredServices: heroData.featuredServices || []
    };
};

// Hook para obtener proyectos del portafolio
export const usePortfolioProjects = () => {
    const { getTranslations } = useLanguage();
    const portfolioData = getTranslations('portfolio');

    return {
        projects: portfolioData.projects || [],
        categories: portfolioData.categories || [],
        title: portfolioData.portfolioTitle,
        subtitle: portfolioData.portfolioSubtitle
    };
};

// Hook para obtener servicios
export const useServices = () => {
    const { getTranslations } = useLanguage();
    const servicesData = getTranslations('services');

    return {
        services: servicesData.servicesList || [],
        title: servicesData.servicesTitle,
        subtitle: servicesData.servicesSubtitle,
        consultNow: servicesData.consultNow
    };
};

// Hook para obtener datos de contacto
export const useContactData = () => {
    const { getTranslations } = useLanguage();
    const contactData = getTranslations('contact') || {};

    // Importar configuración de contacto
    const contactConfig = {
        phone: {
            display: process.env.REACT_APP_PHONE_NUMBER || '+1 (346) 213-5545',
            clean: process.env.REACT_APP_PHONE_CLEAN || '13462135545',
        },
        email: {
            address: process.env.REACT_APP_EMAIL || 'njdesignprint@gmail.com',
        },
        company: {
            location: process.env.REACT_APP_LOCATION || 'Houston, Texas'
        }
    };

    // Reemplazar valores dinámicos
    const processedData = {
        ...contactData,
        details: {
            phoneNumber: contactConfig.phone.display,
            emailAddress: contactConfig.email.address,
            address: contactConfig.company.location
        },
        floating: (contactData && contactData.floatingContact) || {}
    };

    return processedData;
};

// Hook para obtener datos del footer
export const useFooterData = () => {
    const { getTranslations } = useLanguage();
    const footerData = getTranslations('footer') || {};

    return footerData;
};

export default useTranslations;
